import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import {
    Overview,
    PersonalId,
    Users,
    CompanyId,
    Settings,
    Theme,
    Insurance,
    Statistic,
    Comment,
    FAQ,
    Contact,
    RightArrow,
} from '../Svg/Svg';

export default function Sidebar() {
    const location = useLocation();
    const menuPath = location.pathname.split('/')[1];
    const subMenuPath = location.pathname.split('/')[2];

    return (
        <ul className="sidebar__navigation">
            <li>
                <NavLink
                    to="dashboard"
                    className={({ isActive }) =>
                        isActive
                            ? 'navigation__link navigation__link--active'
                            : 'navigation__link'
                    }
                >
                    <Overview />
                    <span className="navigation__link-text">Dashboard</span>
                </NavLink>
            </li>
            <li>
                <NavLink
                    to="users"
                    className={({ isActive }) =>
                        isActive
                            ? 'navigation__link navigation__link--active'
                            : 'navigation__link'
                    }
                >
                    <PersonalId />
                    <span className="navigation__link-text">Users</span>
                </NavLink>
            </li>
            <li>
                <NavLink
                    to="products"
                    className={({ isActive }) =>
                        isActive
                            ? 'navigation__link navigation__link--active'
                            : 'navigation__link'
                    }
                >
                    <CompanyId />
                    <span className="navigation__link-text">Products</span>
                </NavLink>
            </li>
            <li>
                <NavLink
                    to="clients"
                    className={({ isActive }) =>
                        isActive
                            ? 'navigation__link navigation__link--active'
                            : 'navigation__link'
                    }
                >
                    <Users />
                    <span className="navigation__link-text">Clients</span>
                </NavLink>
            </li>
            <li>
                <NavLink
                    to="themes"
                    className={({ isActive }) =>
                        isActive
                            ? 'navigation__link navigation__link--active'
                            : 'navigation__link'
                    }
                >
                    <Theme />
                    <span className="navigation__link-text">Themes</span>
                </NavLink>
            </li>
            <li>
                <NavLink
                    to="insurance"
                    className={({ isActive }) =>
                        isActive
                            ? 'navigation__link navigation__link--active'
                            : 'navigation__link'
                    }
                >
                    <Insurance />
                    <span className="navigation__link-text">Insurance</span>
                </NavLink>
            </li>
            <li>
                <NavLink
                    to="communication/general"
                    className={({ isActive }) =>
                        isActive || menuPath === 'communication'
                            ? 'navigation__link navigation__link--active'
                            : 'navigation__link'
                    }
                >
                    <Comment />
                    <span className="navigation__link-text">
                        User comunication
                    </span>
                </NavLink>
            </li>
            <li className="navigation__item--has-submenu">
                <div
                    className={`navigation__link ${
                        menuPath === 'statistic'
                            ? 'navigation__link--active'
                            : ''
                    }`}
                >
                    <Statistic />
                    <span className="navigation__link-text">Statistic</span>
                    <span className="navigation__link-arrow">
                        <RightArrow />
                    </span>
                    <ul className="sidebar__navigation">
                        <li>
                            <NavLink
                                to="statistic/users"
                                className={({ isActive }) =>
                                    isActive || subMenuPath === 'users'
                                        ? 'navigation__link navigation__link--active'
                                        : 'navigation__link'
                                }
                            >
                                <Users />
                                <span className="navigation__link-text">
                                    User’s KPIs
                                </span>
                            </NavLink>
                        </li>
                        <li>
                            <NavLink
                                to="statistic/insurance"
                                className={({ isActive }) =>
                                    isActive || subMenuPath === 'insurance'
                                        ? 'navigation__link navigation__link--active'
                                        : 'navigation__link'
                                }
                            >
                                <Insurance />
                                <span className="navigation__link-text">
                                    Insurance
                                </span>
                            </NavLink>
                        </li>
                    </ul>
                </div>
            </li>
            <li>
                <NavLink
                    to="contact"
                    className={({ isActive }) =>
                        isActive
                            ? 'navigation__link navigation__link--active'
                            : 'navigation__link'
                    }
                >
                    <Contact />
                    <span className="navigation__link-text">Contact page</span>
                </NavLink>
            </li>
            <li>
                <NavLink
                    to="faq"
                    className={({ isActive }) =>
                        isActive
                            ? 'navigation__link navigation__link--active'
                            : 'navigation__link'
                    }
                >
                    <FAQ />
                    <span className="navigation__link-text">FAQ</span>
                </NavLink>
            </li>
            <li>
                <NavLink
                    to="settings/general"
                    className={({ isActive }) =>
                        isActive || menuPath === 'settings'
                            ? 'navigation__link navigation__link--active'
                            : 'navigation__link'
                    }
                >
                    <Settings />
                    <span className="navigation__link-text">Settings</span>
                </NavLink>
            </li>
        </ul>
    );
}
